import _objectWithoutProperties from "/vercel/path1/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["assistant"];
import React from "react";
var __jsx = React.createElement;
import { useStoreState } from "pullstate";
import Store from "../../../utils/Store";
import Draggable from "react-draggable";
import { useState, useCallback, memo, useEffect, useRef } from "react";
import AwesomeIcon from "../../AwesomeIcon";
import { faWindowMaximize, faXmark } from "@fortawesome/pro-regular-svg-icons";
import getEnv from "../../../utils/getEnv";
import { get } from "lodash";
import { useRouter } from "next/router";
import { useAuth } from "@qure/qure-auth";
var NODE_ENV = getEnv("NODE_ENV");
var isProdEnv = NODE_ENV === "production";
var DraggableModal = /*#__PURE__*/memo(function (_ref) {
  var children = _ref.children;
  var _useAuth = useAuth(),
    userInfo = _useAuth.userInfo;
  var _useStoreState = useStoreState(Store, function (s) {
      return {
        isDraggableModalOpen: s.isDraggableModalOpen,
        isDraggableModalMinimized: s.isDraggableModalMinimized,
        isDraggableModalMaximized: s.isDraggableModalMaximized
      };
    }),
    isDraggableModalOpen = _useStoreState.isDraggableModalOpen,
    isDraggableModalMinimized = _useStoreState.isDraggableModalMinimized,
    isDraggableModalMaximized = _useStoreState.isDraggableModalMaximized;
  var modalRef = useRef(null);

  // get the isAIEnabled from userInfo
  var isAIAssistantEnabled = get(userInfo, ["settings", "ui_settings", "ai_assistant"], false);
  var _useState = useState(false),
    isDragging = _useState[0],
    setIsDragging = _useState[1];
  var _useState2 = useState({
      x: 0,
      y: 0
    }),
    position = _useState2[0],
    setPosition = _useState2[1];
  var _useState3 = useState(false),
    isMobile = _useState3[0],
    setIsMobile = _useState3[1];
  useEffect(function () {
    if (typeof window !== "undefined") {
      setIsMobile(window.matchMedia("(max-width: 639px)").matches);
    }
  }, []);
  var router = useRouter();
  useEffect(function () {
    if (isMobile) {
      // On mobile, open modal if assistant=open in URL
      var shouldOpen = router.query.assistant === "open";
      Store.update(function (s) {
        s.isDraggableModalOpen = shouldOpen;
        s.isDraggableModalMaximized = shouldOpen;
        s.isDraggableModalMinimized = false;
      });
    } else {
      // Desktop: keep previous logic
      // Store.update((s: IStore) => {
      //   s.isDraggableModalOpen = !isProdEnv && isAIAssistantEnabled && !isMobile;
      // });
    }
    // Listen to router changes
  }, [isMobile, router.query.assistant, isAIAssistantEnabled]);
  var handleDragStart = useCallback(function () {
    setIsDragging(true);
  }, []);
  var handleDragStop = useCallback(function (e, data) {
    setIsDragging(false);
    setPosition({
      x: data.x,
      y: data.y
    });
  }, []);
  var handleRestore = useCallback(function () {
    Store.update(function (s) {
      s.isDraggableModalMinimized = false;
    });
    setPosition({
      x: 0,
      y: 0
    });
  }, []);
  if (!isDraggableModalOpen) return null;

  // On mobile, close should remove assistant param
  var handleCloseMobile = function handleCloseMobile() {
    var _router$query = router.query,
      assistant = _router$query.assistant,
      rest = _objectWithoutProperties(_router$query, _excluded);
    router.replace({
      pathname: router.pathname,
      query: rest
    }, undefined, {
      shallow: true
    });
    Store.update(function (s) {
      s.isDraggableModalOpen = false;
      s.isDraggableModalMaximized = false;
      s.isDraggableModalMinimized = false;
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "fixed inset-0 z-50 flex ".concat(isMobile ? "items-stretch justify-stretch" : "items-start justify-end", " pointer-events-none transition-opacity duration-300 ").concat(isDraggableModalOpen ? "opacity-100" : "opacity-0")
  }, isMobile ? /*#__PURE__*/React.createElement("div", {
    className: "relative bg-white dark:bg-gray-900 w-full h-full m-0 overflow-auto flex flex-col pointer-events-auto will-change-transform transition-all duration-300 ease-in-out"
  }, /*#__PURE__*/React.createElement("div", {
    className: "absolute top-4 right-4 z-10"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleCloseMobile,
    "aria-label": "Close",
    className: "text-gray-700 hidden dark:text-gray-100 rounded-full p-2 shadow hover:bg-gray-300 dark:hover:bg-gray-700"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faXmark,
    size: "lg"
  }))), /*#__PURE__*/React.createElement("div", {
    style: {
      paddingTop: "env(safe-area-inset-top, 1rem)",
      paddingBottom: "env(safe-area-inset-bottom, 1rem)"
    },
    className: "flex-1 flex flex-col"
  }, children)) : /*#__PURE__*/React.createElement(Draggable, {
    handle: ".drag-handle",
    onStart: handleDragStart,
    onStop: handleDragStop,
    grid: [50, 50],
    position: isDraggableModalMaximized ? {
      x: 0,
      y: 0
    } : position,
    disabled: isDraggableModalMaximized,
    bounds: "parent"
  }, /*#__PURE__*/React.createElement("div", {
    ref: modalRef,
    className: "relative bg-white dark:bg-gray-900 rounded-lg shadow-[0_0_15px_rgba(0,0,0,0.1)] dark:shadow-[0_0_15px_rgba(0,0,0,0.3)] ".concat(isDraggableModalMaximized ? "w-full h-[100vh] m-0" : "w-[calc(40%-2rem)] max-w-[calc(40%-2rem)] h-[98vh] mt-4 mr-4 border border-teal-500 dark:border-teal-400", " overflow-auto flex flex-col pointer-events-auto will-change-transform transition-all duration-300 ease-in-out ").concat(!isDragging && "transition-transform duration-300 ease-in-out", " ").concat(isDraggableModalOpen ? "translate-x-10" : "translate-x-full", " ").concat(isDraggableModalMinimized ? "hidden" : "")
  }, /*#__PURE__*/React.createElement("div", {
    className: "flex flex-col h-full pb-1 ".concat(isDraggableModalMaximized ? "w-[70%] mx-auto border border-gray-200 dark:border-gray-800" : "")
  }, children)))), isDraggableModalMinimized && /*#__PURE__*/React.createElement("div", {
    className: "fixed right-[calc(6rem)] top-[60px] z-[100]"
  }, /*#__PURE__*/React.createElement("button", {
    onClick: handleRestore,
    className: "bg-teal-500 hover:bg-teal-600 text-white py-3 px-5 rounded-lg shadow-[0_8px_24px_rgba(0,0,0,0.25)] hover:shadow-[0_12px_32px_rgba(0,0,0,0.35)] transition-all duration-300 hover:scale-110 pointer-events-auto group flex items-center space-x-2",
    "aria-label": "Restore"
  }, /*#__PURE__*/React.createElement(AwesomeIcon, {
    name: faWindowMaximize,
    size: "lg",
    className: "text-white"
  }), /*#__PURE__*/React.createElement("span", {
    className: "opacity-0 w-0 overflow-hidden group-hover:opacity-100 group-hover:w-auto transition-all duration-300 whitespace-nowrap"
  }, "Restore"))));
});
DraggableModal.displayName = "DraggableModal";
export default DraggableModal;